import React, { Component } from "react";
import Pagination from "react-bootstrap/Pagination";
import "./pagination-component.css";


export class PaginationExhibit2 extends Component {
    constructor(props) {
        super(props);
        handleLoad = handleLoad.bind(this);
    }

    componentDidMount() {
        const { action, pages, modalPagination } = this.props;
        window.addEventListener("DOMContentLoaded", () => handleLoad(action, pages, modalPagination));
    }
    
    componentWillUnmount() {
        const { action, pages, modalPagination } = this.props;
        window.removeEventListener("DOMContentLoaded", () => handleLoad(action, pages, modalPagination));
    }

    handlerChangeSize = (event) => {
        this.props.resizePage(event.target.value);
    }

    render() {
        const { action, pages, modalPagination, hidePageSizeSelection } = this.props;
        return (
            <div className="pagination-container">
                <Pagination>
                    {displayFirst(action, pages)}
                    {displayPrevious(action, pages)}
                    {displayPages(action, pages, modalPagination)}
                    {displayNext(action, pages)}
                    {displayLast(action, pages)}
                </Pagination>
                {
                    this.props.resizePage !== undefined &&
                    <>
                        <span className="page-size" hidden={hidePageSizeSelection}>Page Size</span>
                        <select hidden={hidePageSizeSelection} value={pages?.PerPage} onChange={(e) => this.handlerChangeSize(e)} className="pagination-page-sizes">
                            {
                                pages?.PageSizes?.map((item, index) => <option key={index} value={item}>{item}</option>)
                            }
                        </select>
                        <span className="total-items">{pages.TotalEntries.toLocaleString()} results found</span>
                    </>
                }
            </div>
        );
    }
}


function handleLoad() {
    var pageList = document.querySelectorAll(".page-list");
    var nextItem = document.querySelectorAll(".next-link");
    var endItem = document.querySelectorAll(".end-link");
    var previousLink = document.querySelectorAll(".previous-link");
    var firstLink = document.querySelectorAll(".first-link");

    pageList.forEach((el) =>
        el.addEventListener("click", (event) => {
            for (let i = 0; pageList.length > i; i++) {
                pageList[i].classList.remove("isSelected");
            }
            el.classList.add("isSelected");
        })
    );

    //go to next page
    nextItem.forEach((el) =>
        el.addEventListener("click", (event) => {
            for (let i = 0; pageList.length > i; i++) {
                if (pageList[i].classList.value.includes("isSelected")) {
                    pageList[i].classList.remove("isSelected");
                    let nextPageIndex = i + 1;
                    
                    // If modalPagination is true and next page index is beyond pageList, do nothing
                    if (this.props.modalPagination) {
                        this.props.action(this.props.pages.PageNumber + 1);
                    } else {
                        let nextPageIndex = i + 1;
                        if (nextPageIndex < pageList.length) {
                            pageList[nextPageIndex].classList.add("isSelected");
                        }
                    }
                    break;
                }
            }
        })
    );

    //go to last item
    endItem.forEach((el) =>
        el.addEventListener("click", (event) => {
            for (let i = 0; pageList.length > i; i++) {
                pageList[i].classList.remove("isSelected");
            }
            pageList[pageList.length - 1].classList.add("isSelected");
        })
    );

    //go to previous item
    previousLink.forEach((el) =>
        el.addEventListener("click", (event) => {
            for (let i = 0; pageList.length > i; i++) {
                if (pageList[i].classList.value.includes("isSelected") && i === 0) {
                    pageList[i].classList.remove("isSelected");
                    
                    // Decrement the page number only if at the beginning of displayed pages
                    if (this.props.modalPagination) {
                        this.props.action(this.props.pages.PageNumber - 1);
                    } else {
                        let prevPageIndex = i - 1;
                        if (prevPageIndex >= 0) {
                            pageList[prevPageIndex].classList.add("isSelected");
                        }
                    }
                    break;
                }
            }
        })
    );

    //got to first Item
    firstLink.forEach((el) =>
        el.addEventListener("click", (event) => {
            for (let i = 0; pageList.length > i; i++) {
                pageList[i].classList.remove("isSelected");
            }
            pageList[0].classList.add("isSelected");
        })
    );
}

function displayPages(action, pages, modalPagination) {
    let items = [];
    let startPage, endPage;

    if (pages.PageNumber === 0) {
        startPage = 0;
        endPage = Math.min(2, pages.TotalPages - 1);
    } else if (pages.PageNumber === pages.TotalPages - 1) {
        startPage = Math.max(0, pages.TotalPages - 3);
        endPage = pages.TotalPages - 1;
    } else {
        startPage = Math.max(0, pages.PageNumber - 1);
        endPage = Math.min(pages.PageNumber + 1, pages.TotalPages - 1);
    }

    for (let i = startPage; i <= endPage; i++) {
        items.push(
            <Pagination.Item
                className={i === pages.PageNumber ? "page-list isSelected" : "page-list"}
                key={"page-item-" + i}
                onClick={() => action(i)}
            >
                {i + 1}
            </Pagination.Item>
        );
    }

    if (endPage < pages.TotalPages - 1) {
        items.push(<Pagination.Ellipsis key="ellipsis" />);
        items.push(
            <Pagination.Item
                className={pages.TotalPages - 1 === pages.PageNumber ? "page-list isSelected" : "page-list"}
                key={"page-item-last"}
                onClick={() => action(pages.TotalPages - 1)}
            >
                {pages.TotalPages}
            </Pagination.Item>
        );
    }

    return <div className="pagination">{items}</div>;
}




function displayFirst(action, pages) {
    return (
        <Pagination.First
            className={`first-link ${!pages.HasPrevious ? "hidden" : ""}`}            
            onClick={(e) => action(0)}
            hidden={!pages.HasPrevious}
        />
    );
}

function displayPrevious(action, pages) {    
    return (
        <Pagination.Prev
            className={`previous-link ${!pages.HasPrevious ? "hidden" : ""}`}
            onClick={(e) => action(pages.PageNumber - 1)}
            hidden={!pages.HasPrevious}
        />
    );
}

function displayNext(action, pages) {
    return (
        <Pagination.Next
            className={`next-link ${!pages.HasNext ? "hidden" : ""}`}
            onClick={(e) => action(pages.PageNumber + 1)}
            hidden={!pages.HasNext}
        />
    );
}

function displayLast(action, pages) {
    return (
        <Pagination.Last
            className={`end-link ${!pages.HasNext ? "hidden" : ""}`}
            onClick={(e) => action(pages.TotalPages - 1)}
            hidden={!pages.HasNext}
        />
    );
}


function displayPagesWithCircuitID(action, pages, endUserID, searchVal) {

    let startPage, endPage;
    if (pages.TotalPages - 1 <= 14) {
        startPage = 0;
        endPage = pages.TotalPages - 1;
    } else {
        if (pages.PageNumber <= 8) {
            startPage = 0;
            endPage = 14;
        } else if (pages.PageNumber + 7 >= pages.TotalPages - 1) {
            startPage = pages.TotalPages - 13;
            endPage = pages.TotalPages - 1;
        } else {
            startPage = pages.PageNumber - 7;
            endPage = pages.PageNumber + 7;
        }
    }

    //calculate start and end item indexes

    let items = [];
    let count = Math.round(endPage / 2);
    for (var i = startPage; i < endPage + 1; i++) {
        if (count > i || i == endPage) {
            items.push(
                <Pagination.Item
                    className={i !== pages.PageNumber ? "page-list" : "page-list isSelected"}
                    key={"li-" + i + 1}
                    onClick={(e) => action(endUserID, searchVal, parseInt(e.target.text) - 1)}
                >
                    {i + 1}
                </Pagination.Item>
            );
        }
        if (count == i) {
            items.push(
                <Pagination.Ellipsis key={"li-" + (i + 1)} />
            );
        }
    }

    return <div className="pagination">{items}</div>;
}
